import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import i18n from "../../../../Utils/i18next/i18next";
const { t } = i18n;
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  registryRights: [],
  availableStatuses: null,
  crmEvents: [],
  originalEvent: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:crm.index" },
      { key: "[s].name", name: "global:crm.status" },
      { key: "[c].name", name: "global:crm.contact" },
      { key: "fundsPurpose", name: "global:crm.fundsPurpose" },
      {
        key: "[cb].firstName+lastName",
        name: "global:crm.createdBy",
      },
    ],
    selectedSearchFields: [
      "index",
      "fundsPurpose",
      "[c].name",
      "[s].name",
      "[cb].firstName+lastName",
    ],
    dictionaryFields: [
      "clientOrigin",
      "processGoal",
      "prognosis",
      "acquisitionSource",
      "eventStatus",
    ],
    url: "crm",
  },
};
const sortByKeys = (items, keys, isAscending) => {
  items?.sort((a, b) => {
    for (const key of keys) {
      const valueA = _.get(a, key);
      const valueB = _.get(b, key);

      if (valueA === valueB) continue;
      if (valueA == null || valueB == null) return valueA == null ? 1 : -1;

      let result = 0;

      if (moment.isMoment(valueA) && moment.isMoment(valueB)) {
        result = valueA.isBefore(valueB) ? -1 : 1;
      } else if (typeof valueA === "string" && typeof valueB === "string") {
        result = valueA.localeCompare(valueB);
      } else {
        result = valueA > valueB ? 1 : -1;
      }

      return isAscending ? result : -result;
    }
    return 0;
  });
};
const crmReducer = createSlice({
  name: "crmReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
    updateCrmEvents: (state, { payload }) => {
      if (!Array.isArray(payload)) return;
      state.crmEvents = payload;
      state.originalEvent = [...payload];
    },
    findClosest: (state) => {
      const futureEvents = state.crmEvents.filter(
        (row) =>
          row.nextEventDate && moment(row.nextEventDate).isAfter(moment())
      );
      if (futureEvents.length === 0) {
        NotificationManager.info(`${t("global:crmEvent.noFind")}`);
        return;
      }
      const closestEvent = futureEvents.reduce((closest, current) => {
        return moment(current.nextEventDate).isBefore(closest.nextEventDate)
          ? current
          : closest;
      });
      state.crmEvents = [closestEvent];
    },
    sortCrmData: (state, { payload }) => {
      const { keys, isAscending } = payload;
      sortByKeys(state.crmEvents, keys, isAscending);
    },
    resetCrmData: (state) => {
      state.crmEvents = [...state.originalEvent];
    },
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
  sortCrmData,
  updateCrmEvents,
  resetCrmData,
  findClosest,
} = crmReducer.actions;

export default crmReducer.reducer;
